<template>
  <div class="container-fluid bg-white py-3">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h3 class="font-weight-bold">
            Welcome to the
          </h3>
          <h3 class="font-weight-bold">
            <span class="text-green text-uppercase">
              Favorable Fitness Factor&reg;
            </span> Health Assessment!
          </h3>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <ul>
            <li><strong>Please fill this out</strong> as accurately as possible. The more information you give us, the better we can help you succeed.</li>
            <li>
              This information will determine your
              <strong>Favorable Fitness Factor®</strong>
              <i
                v-tooltip:top="'An overall score of health, like a school report card grade, that analyzes your Health Assessment inputs that include: 1) Eating Habits, 2) Exercise Routine, 3) Lab Values and Medical History, and 4) Lifestyle Habits.'"
                class="fa fa-info-circle text-primary d-inline"
              />
              and Individual Factor
              <i
                v-tooltip:top="'Total number of Food Factors you are encouraged to eat daily. To stay healthy, add Food Factors together during breakfast, lunch, dinner, and snack, and hit your Individual Factor.'"
                class="fa fa-info-circle text-primary d-inline"
              />
              .
            </li>
            <li><strong>Return</strong> to this page frequently and update the information so you can track your progress.</li>
          </ul>
        </div>
      </div>
      <hr>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12">
          <p>
            You are currently taking the <span class="text-bold"><span v-text="short_assessment ? 'SHORT' : 'FULL'" /> assessment</span>.
            <i
              v-tooltip:top="short_assessment ? shortAssessmentDescription : fullAssessmentDescription"
              class="fa fa-info-circle text-primary d-inline"
            ></i>
            <button
              class="btn btn-link"
              @click="short_assessment = !short_assessment"
            >
              Switch to the <span class="text-bold"><span v-text="short_assessment ? 'FULL' : 'SHORT'" /> assessment</span>. &rarr;
            </button>
            <i
              v-tooltip:top="short_assessment ? fullAssessmentDescription : shortAssessmentDescription"
              class="fa fa-info-circle text-primary d-inline"
            ></i>
          </p>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-12">
          <div
            v-if="!hasHealthData"
            class="row"
          >
            <div class="col-12">
              <div class="alert alert-info">
                It looks like you don't have any health data saved yet.  Fill the form out to the best of your ability and submit it to get your <strong>Favorable Fitness Factor®</strong> and your Health Scorecard.
              </div>
            </div>
          </div>
          <form
            id="healthTabContent"
            ref="form"
            data-spy="scroll"
            data-target="healthTab"
            data-offset="0"
            @submit.prevent="save"
          >
            <div id="general">
              <div class="row">
                <div class="col-12">
                  <health-data-general :short-assessment="short_assessment" />
                </div>
              </div>
            </div>
            <hr>
            <div id="eating">
              <div class="row">
                <div class="col-12">
                  <health-data-eating :short-assessment="short_assessment" />
                </div>
              </div>
            </div>
            <div
              v-if="!short_assessment"
              id="exercise"
            >
              <hr>
              <div class="row">
                <div class="col-12">
                  <health-data-exercise />
                </div>
              </div>
            </div>
            <div
              v-if="!short_assessment"
              id="medical"
            >
              <hr>
              <div class="row">
                <div class="col-12">
                  <health-data-medical />
                </div>
              </div>
            </div>
            <div
              v-if="!short_assessment"
              id="lifestyle"
            >
              <hr>
              <div class="row">
                <div class="col-12">
                  <health-data-lifestyle />
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-12">
                <notifications />
                <button
                  type="submit"
                  class="btn btn-primary"
                >
                  Save &amp; View Scorecard
                </button>
              </div>
            </div>
          </form>

          <HealthSources class="my-4" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../store.js'
import HealthSources from "../components/HealthSources.vue";

export default {
  components: {
    HealthSources,
    'health-data-general': require('../components/HealthDataComponents/General.vue').default,
    'health-data-eating': require('../components/HealthDataComponents/Eating.vue').default,
    'health-data-exercise': require('../components/HealthDataComponents/Exercise.vue').default,
    'health-data-medical': require('../components/HealthDataComponents/Medical.vue').default,
    'health-data-lifestyle': require('../components/HealthDataComponents/Lifestyle.vue').default
  },
  beforeRouteEnter(to,from,next){
    store.dispatch('healthData/GET_INITIAL_DATA').then(() => {
      next();
    }).catch(() => {
      next();
    })
  },
  data () {
    return {
      shortAssessmentDescription: 'This assessment will take you to the FOOD SPIRAL® you choose, provide you with your daily IF (Individual Factor – see FAQ sheet) and straight to the FOOD SPIRAL Food Tracker.',
      fullAssessmentDescription: 'This assessment is a comprehensive profile of your food intake, exercise, medical history, labs and lifestyle, takes longer but the information provided is valuable for your health journey.',
    };
  },
  computed: {
    hasHealthData() {
      return !this.$store.state.healthData.nodata;
    },
    short_assessment: {
      get() {
        return this.$store.state.healthData.shortAssessment;
      },
      set(val) {
        this.$store.commit('healthData/UPDATE_SHORT_ASSESSMENT', val);
      },
    },
    authenticated() {
      return this.$store.getters['user/authenticated'];
    }
  },
  mounted() {
    if (this.$route.query.type) {
      this.$store.commit('healthData/UPDATE_SHORT_ASSESSMENT', this.$route.query.type === 'short');

      return;
    }

    this.$store.commit('healthData/UPDATE_SHORT_ASSESSMENT', window.innerWidth < 800 || !this.authenticated);
  },
  methods: {
    save() {
      if (this.$refs.form.checkValidity()) {
        this.$store.dispatch('healthData/SAVE_NEW_DATA').then(() => {
          this.$store.dispatch('user/getUser');
          this.$router.push({ name: 'scorecard' })
          this.$store.dispatch('notifications/setSuccess', 'Health Assessment entry added.');
        }).catch(err => {
          this.$store.dispatch('notifications/setError', err.response.data.message || 'An error occurred.');
          this.$store.dispatch('notifications/setErrorBag', err.response.data.errors);
        });
      } else {
        this.$refs.form.reportValidity();
      }
    },
    reset() {
      this.$store.dispatch('healthData/RESET');
    }
  },
}
</script>
